import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

export interface SampleRequestModel {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    emailAddress: string;
    productName: string;
    productSku: string;
    productBrand: string;
    quantity: number;
    companyName: string;
    billingAddress: SampleAddress;
    message: string;
    projectAddress: SampleAddress;
    shippingAddress: SampleAddress;
    location: string;
    emailTo: string;
    topic: string;
}

export interface SampleAddress {
    addressLine1?: string;
    addressLine2?: string;
    addressLine3?: string;
    countryId?: string;
    stateId?: string;
    stateName?: string;
    city?: string;
    postalCode?: string;
}

type AuthenticatedSampleRequestFormParameter = {
    sampleRequestModel: SampleRequestModel;
} & HasOnSuccess;

interface AuthenticatedSampleRequestFormApiParameter extends ApiParameter {
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    emailAddress?: string;
    productName?: string;
    productSku?: string;
    productBrand?: string;
    quantity?: number;
    companyName?: string;
    billingAddress?: SampleAddress;
    message?: string;
    projectAddress?: SampleAddress;
    shippingAddress?: SampleAddress;
    location?: string;
    emailTo?: string;
    topic?: string;
    consent?: boolean;
}

type HandlerType = ApiHandlerDiscreteParameter<AuthenticatedSampleRequestFormParameter, AuthenticatedSampleRequestFormApiParameter>;

const emailsUrlExtension = "/api/v1/emailExtensions";

export function ucsRequestSampleForm(parameter: AuthenticatedSampleRequestFormApiParameter) {
    return post<AuthenticatedSampleRequestFormApiParameter, void>(`${emailsUrlExtension}/authenticatedSample`, parameter);
}

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        firstName: props.parameter.sampleRequestModel.firstName,
        lastName: props.parameter.sampleRequestModel.lastName,
        phoneNumber: props.parameter.sampleRequestModel.phoneNumber,
        emailAddress: props.parameter.sampleRequestModel.emailAddress,
        productName: props.parameter.sampleRequestModel.productName,
        productSku: props.parameter.sampleRequestModel.productSku,
        productBrand: props.parameter.sampleRequestModel.productBrand,
        quantity: props.parameter.sampleRequestModel.quantity,
        companyName: props.parameter.sampleRequestModel.companyName,
        billingAddress: props.parameter.sampleRequestModel.billingAddress,
        message: props.parameter.sampleRequestModel.message,
        projectAddress: props.parameter.sampleRequestModel.projectAddress,
        shippingAddress: props.parameter.sampleRequestModel.shippingAddress,
        location: props.parameter.sampleRequestModel.location,
        emailTo: props.parameter.sampleRequestModel.emailTo,
        topic: props.parameter.sampleRequestModel.topic,
        consent: false,
    };
};

export const SendDataToApi: HandlerType = async props => {
    await ucsRequestSampleForm(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const ucsAuthenticatedSampleRequest = createHandlerChainRunner(chain, "ucsAuthenticatedSampleRequest");
export default ucsAuthenticatedSampleRequest;
